import { forwardRef, type HTMLAttributes } from 'react';

import { inputVariants } from '../../../atoms/inputs/inputVariants';
import { cn } from '../../../utils';
import { useMultiselectContext } from '../MultiselectInput.context';

export const MultiselectInputBox = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  const { error } = useMultiselectContext();

  return (
    <div
      ref={ref}
      className={cn(
        inputVariants({ variant: 'default' }),
        'flex flex-row items-center px-3 py-4 overflow-hidden h-fit',
        'focus-within:ring-1 focus-within:ring-ring',
        error && 'border-destructive focus-within:ring-destructive',
        className,
      )}
      {...props}
    />
  );
});
